import React from 'react'
import styles from "./styles/bookmarkIconStyles.module.css"
const BookmarkIconFilled = () => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.68555 5.88807C2.68555 2.73542 5.24128 0.179688 8.39393 0.179688H15.6045C18.7572 0.179688 21.3129 2.73542 21.3129 5.88807V21.7133C21.3129 23.3772 19.4722 24.3821 18.0725 23.4824L12.8115 20.1003C12.3167 19.7822 11.6817 19.7822 11.1869 20.1003L5.9259 23.4824C4.52627 24.3821 2.68555 23.3772 2.68555 21.7133V5.88807ZM8.39393 6.78939C7.89614 6.78939 7.4926 7.19293 7.4926 7.69071C7.4926 8.1885 7.89614 8.59204 8.39393 8.59204H15.6045C16.1023 8.59204 16.5058 8.1885 16.5058 7.69071C16.5058 7.19293 16.1023 6.78939 15.6045 6.78939H8.39393Z" fill="#2B3F6C" />
        </svg>


    )
}

export default BookmarkIconFilled